var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FontAwesomeIcon',_vm._b({attrs:{"icon":_vm.faIcon}},'FontAwesomeIcon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }